import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type { PostalCodeDTO, WrapperResponsePostalCodeDTO } from '../core/models';

export type { PostalCodeDTO, WrapperResponsePostalCodeDTO } from '../core/models';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getByZipCode(zipCode: string): Observable<WrapperResponsePostalCodeDTO> {
    return this.http.get<WrapperResponsePostalCodeDTO>(
      `${this.apiUrl}/addresses/postal-codes/${encodeURIComponent(zipCode)}`
    );
  }
}
